import React, { useEffect } from "react";
import {
  ListItemIcon,
  ListItemText,
  Box,
  Collapse,
  styled,
  ListItem,
  useTheme,
  IconButton,
  Tooltip,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SearchIcon from "@mui/icons-material/Search";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import PaidIcon from "@mui/icons-material/Paid";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import InventoryIcon from "@mui/icons-material/Inventory";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { StyledIcon } from "../../StyledIcon/StyledIcon";
import { generateFilter } from "colorize-filter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import { generatePermissionMatcher } from "../../../utils";
import { TypesPermissions } from "../../Routes/TypesPermissions";
import { useAuth } from "../../../contexts/authentication/AuthenticationContext";
import { useFlags } from "flagsmith/react";
import { sidebar } from "../../../utils/featureFlags";

const collapseDefaultStateOpen = true;

export enum Roles {
  ADMIN = "admin",
  ANALYST = "vendor",
  CLIENT = "customer",
}

interface LisItemProps {
  title?: string;
  titleFooter?: string;
  icon?: React.ReactNode;
  to: string;
  module: string;
  collapseIsOpen: boolean;
  subMenu?: Array<{
    hasPermission?: (_: string) => boolean;
    title: string;
    to: string;
    module: string;
    icon?: React.ReactNode;
    flag: string;
  }>;
}

interface ListItemSideBarProps {
  isCompact?: boolean;
  onToggleCompact?: () => void;
}

const listHome: LisItemProps[] = [
  {
    title: "Dashboard",
    icon: <StyledIcon iconType="dashboard" />,
    to: routesConfig.HOME,
    module: "dashboard",
    collapseIsOpen: collapseDefaultStateOpen,
  },
];

const listMenu: LisItemProps[] = [
  // {
  //   title: "Executivo",
  //   icon: <StyledIcon iconType="executive" />,
  //   to: "#",
  //   module: "executivo",
  //   collapseIsOpen: collapseDefaultStateOpen,
  //   subMenu: [
  //     {
  //       title: "Consultar preços",
  //       to: routesConfig.EXECUTIVE().PRICE,
  //       module: "",
  //     },
  //     {
  //       title: "Consultar parâmetros mensais",
  //       to: routesConfig.EXECUTIVE().MONTHLY_PARAMETERS,
  //       module: "",
  //     },
  //     {
  //       title: "Consultar condições operacionais",
  //       to: routesConfig.EXECUTIVE().OPERATING_CONDITIONS,
  //       module: "",
  //     },
  //   ],
  // },
  {
    title: "Financeiro",
    icon: <StyledIcon iconType="finantial" />,
    to: "#",
    module: "financeiro",
    collapseIsOpen: collapseDefaultStateOpen,
    subMenu: [
      {
        flag: "sidebar_financial_invoices",
        hasPermission: generatePermissionMatcher(TypesPermissions.INVOICES),
        title: "Consultar NFE",
        to: routesConfig.FINANCIAL().INVOICES,
        module: "",
        icon: <SearchIcon />,
      },
      {
        flag: "sidebar_financial_movement",
        hasPermission: generatePermissionMatcher(TypesPermissions.MOVEMENT),
        title: "Consultar movimentação financeira",
        to: routesConfig.FINANCIAL().MOVEMENT,
        module: "",
        icon: <ContentPasteSearchIcon />,
      },
      {
        flag: "sidebar_financial_statement",
        hasPermission: generatePermissionMatcher(TypesPermissions.STATEMENT),
        title: "Consultar extrato",
        to: routesConfig.FINANCIAL().STATEMENT,
        module: "",
        icon: <ReceiptIcon />,
      },
      {
        flag: "sidebar_financial_refunds_icms",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.TAX_REIMBURSEMENT
        ),
        title: "Ressarcimento Fiscal",
        to: routesConfig.FINANCIAL().TAX_REIMBURSEMENT,
        module: "",
        icon: <ManageSearchIcon />,
      },
    ],
  },
  {
    title: "Suprimentos",
    icon: <StyledIcon iconType="supplies" />,
    to: "#",
    module: "suprimentos",
    collapseIsOpen: collapseDefaultStateOpen,
    subMenu: [
      {
        flag: "sidebar_supply_quote_extract",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.QUOTE_EXTRACT
        ),
        title: "Extrato de cota",
        to: routesConfig.SUPPLIES().QUOTE_EXTRACT,
        module: "",
        icon: <RequestQuoteIcon />,
      },
      {
        flag: "sidebar_supply_quote_balance",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.QUOTE_BALANCE
        ),
        title: "Saldo de cota",
        to: routesConfig.SUPPLIES().QUOTE_BALANCE,
        module: "",
        icon: <PaidIcon />,
      },
      {
        flag: "sidebar_supply_quote",
        hasPermission: generatePermissionMatcher(TypesPermissions.QUOTE),
        title: "Pedidos de cota",
        to: routesConfig.SUPPLIES().QUOTE,
        module: "",
        icon: <PriceChangeIcon />,
      },
      // {
      //   title: "Consultar cota do mês seguinte",
      //   to: routesConfig.SUPPLIES().QUOTE,
      //   module: "",
      // },
    ],
  },
  {
    title: "Operacional",
    icon: <StyledIcon iconType="operational" />,
    to: "#",
    module: "operacional",
    collapseIsOpen: collapseDefaultStateOpen,
    subMenu: [
      {
        flag: "sidebar_operational_pipelines",
        hasPermission: generatePermissionMatcher(TypesPermissions.PIPELINES),

        title: "Entregas dutoviárias",
        to: routesConfig.OPERATIONAL().PIPELINES,
        module: "",
        icon: <AccountTreeIcon />,
      },
      {
        flag: "sidebar_operational_road_stations",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.ROAD_STATIONS
        ),

        title: "Entregas rodoviárias",
        to: routesConfig.OPERATIONAL().ROAD_STATIONS,
        module: "",
        icon: <LocalShippingIcon />,
      },
      {
        flag: "sidebar_operational_river",
        hasPermission: generatePermissionMatcher(TypesPermissions.RIVER),

        title: "Entregas Fluviais",
        to: routesConfig.OPERATIONAL().RIVER,
        module: "",
        icon: <DirectionsBoatIcon />,
      },
    ],
  },
  {
    title: "Armazenagem",
    icon: <StyledIcon iconType="operational" />,
    to: "#",
    module: "armazenagem",
    collapseIsOpen: collapseDefaultStateOpen,
    subMenu: [
      {
        flag: "sidebar_storage_river_discharges",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.STORAGE_RIVER_DISCHARGES
        ),
        title: "Descargas",
        to: routesConfig.STORAGE().RIVER_DISCHARGES,
        module: "",
        icon: <UnarchiveIcon />,
      },
      {
        flag: "sidebar_storage_pipelines",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.STORAGE_PIPELINES
        ),
        title: "Entregas",
        to: routesConfig.STORAGE().PIPELINES,
        module: "",
        icon: <InventoryIcon />,
      },
      {
        flag: "sidebar_storage_quote_balance",
        hasPermission: generatePermissionMatcher(
          TypesPermissions.STORAGE_QUOTE_BALANCE
        ),
        title: "Consultar saldo",
        to: routesConfig.STORAGE().QUOTE_BALANCE,
        module: "",
        icon: <MonetizationOnIcon />,
      },
    ],
  },

  {
    title: "Informação",
    icon: <StyledIcon iconType="sac" />,
    to: "#",
    module: "informacao",
    collapseIsOpen: collapseDefaultStateOpen,
    subMenu: [
      {
        flag: "sidebar_operational_road_stations",
        hasPermission: () => true,
        title: "SAC",
        to: routesConfig.INFORMATION().SAC,
        module: "",
        icon: <HelpCenterIcon />,
      },
    ],
  },
];

const menuFooter: LisItemProps[] = [
  // {
  //   title: "Informação",
  //   icon: <StyledIcon iconType="operational" />,
  //   to: "#",
  //   module: "informacao",
  //   collapseIsOpen: collapseDefaultStateOpen,
  //   subMenu: [
  //     {
  //       title: "Visualizar avisos",
  //       to: routesConfig.WARNINGS,
  //       module: "avisos",
  //       icon: <StyledIcon iconType="suitcase" />,
  //     },
  //     {
  //       title: "SAC",
  //       to: routesConfig.SAC,
  //       module: "sac",
  //       icon: <StyledIcon iconType="sac" />,
  //     },
  //   ],
  // },
  // {
  //   title: "Configurações",
  //   icon: <StyledIcon iconType="operational" />,
  //   to: "#",
  //   module: "informacao",
  //   collapseIsOpen: collapseDefaultStateOpen,
  //   subMenu: [
  //     {
  //       title: "Acessos",
  //       to: routesConfig.HITS,
  //       module: "acessos",
  //       icon: <StyledIcon iconType="suitcase" />,
  //     },
  //   ],
  // },
];

const List = styled("div")<{ isCompact?: boolean }>(({ isCompact }) => ({
  "& #home": {
    fontFamily: "Archivo, sans-serif",
    fontSize: "20px",
    color: "#58595B",
    fontWeight: "600",
    paddingLeft: "16px",
    paddingBottom: "10px",
  },
  "& #titleMenu": {
    fontFamily: "Archivo",
    color: "#58595B",
    fontWeight: "600",
  },
  "& #subTitleMenu": {
    fontFamily: "Archivo, sans-serif",
    paddingLeft: "10px",
    fontStyle: "normal",
    fontSize: "14px",
    color: "#58595B",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
    },
  },
  "& .MuiBox-root .MuiSvgIcon-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "bold",
  },
  "& .MuiListItemIcon-root .MuiSvgIcon-root": {
    fontSize: "18px",
    fontWeight: "bold",
  },
  "& .MuiSvgIcon-root": {
    fontWeight: "bold",
  },
  "& .footerTitle": {
    paddingTop: "20px",
  },
  ...(isCompact && {
    "& .MuiListItemIcon-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  }),
}));

const listItemSideBar: React.FC<ListItemSideBarProps> = ({
  isCompact = false,
  onToggleCompact,
}) => {
  const flags = useFlags(sidebar);
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [menuList, setListMenu] = React.useState(listMenu);

  useEffect(() => {
    const filteredMenus = listMenu.map((menuEntry: LisItemProps) => ({
      ...menuEntry,
      subMenu: filterSubMenu(menuEntry.subMenu),
    }));
    setListMenu([...listHome, ...filteredMenus]);
  }, []);

  const filterSubMenu = (subMenu: LisItemProps["subMenu"]) => {
    if (!auth) return;
    const isAdmin = auth.roles.has(Roles.ADMIN);

    if (isAdmin) {
      return subMenu?.filter((subMenuEntry) => {
        if (subMenuEntry?.flag) {
          return flags[subMenuEntry.flag].enabled;
        }
        return true;
      });
    } else {
      const userPermissions = auth.permissionSet.SYSTEM_MODULES;
      return subMenu?.filter((subMenuEntry) => {
        return (
          !subMenuEntry.hasPermission ||
          (userPermissions.some(subMenuEntry.hasPermission) &&
            flags[subMenuEntry.flag].enabled)
        );
      });
    }
  };

  return (
    <Box
      sx={{
        px: isCompact ? "8px" : "20px",
        py: "10px",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        width: "100%",
        maxWidth: "100%",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "rgba(0,0,0,0.05)",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,0.2)",
          borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "rgba(0,0,0,0.3)",
        },
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          justifyContent: isCompact ? "center" : "flex-end",
          mb: 1,
        }}
      >
        <IconButton
          onClick={onToggleCompact}
          size="small"
          sx={{
            color: "#58595B",
            "&:hover": {
              backgroundColor: "rgba(226, 15, 26, 0.1)",
              color: theme.palette.primary.main,
            },
          }}
        >
          {isCompact ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>

      <List
        isCompact={isCompact}
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          overflow: "hidden",
        }}
        aria-labelledby="nested-list-subheader"
      >
        {!isCompact && <div id="home">Home</div>}
        {menuList?.map((item, index) => (
          <List key={index}>
            {item.title === "Dashboard" && (
              <Tooltip title={isCompact ? item.title : ""} placement="right">
                <ListItem
                  component={Link}
                  to={item.to}
                  sx={{
                    borderRadius: "4px",
                    justifyContent: isCompact ? "center" : "flex-start",
                    px: isCompact ? 1 : 2,
                    "& .MuiSvgIcon-root": {
                      color: "#58595B",
                    },

                    "&:hover": {
                      background: "rgba(226, 15, 26, 0.1);",
                      color: theme.palette.primary.main,
                      cursor: "pointer",
                      filter: generateFilter(`${theme.palette.primary.main}`),
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: isCompact ? "auto" : 56 }}>
                    {item.icon}
                  </ListItemIcon>
                  {!isCompact && (
                    <ListItemText>
                      <div id="titleMenu">{item.title}</div>
                    </ListItemText>
                  )}
                </ListItem>
              </Tooltip>
            )}

            {!!item.subMenu?.length && (
              <Tooltip title={isCompact ? item.title : ""} placement="right">
                <ListItem
                  component="div"
                  selected={location.pathname.includes(item.module)}
                  sx={{
                    borderRadius: "4px",
                    justifyContent: isCompact ? "center" : "flex-start",
                    px: isCompact ? 1 : 2,
                    position: "relative",
                    "& .MuiSvgIcon-root": {
                      color: "#58595B",
                    },

                    "&:hover": {
                      background: "rgba(226, 15, 26, 0.1);",
                      color: theme.palette.primary.main,
                      cursor: "pointer",
                      filter: generateFilter(`${theme.palette.primary.main}`),
                    },
                    ...(location.pathname.includes(item.module) &&
                    !item.subMenu?.length
                      ? {
                          color: theme.palette.primary.main,
                          filter: generateFilter(theme.palette.primary.main),
                          bgcolor: "rgba(226, 15, 26, 0.1);",
                        }
                      : {
                          "&.Mui-selected": {
                            backgroundColor: "transparent",
                            color: theme.palette.primary.main,
                            filter: generateFilter(theme.palette.primary.main),
                          },
                        }),
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const newListMenu = [...menuList];
                    newListMenu[index].collapseIsOpen =
                      !newListMenu[index].collapseIsOpen;
                    setListMenu(newListMenu);
                  }}
                >
                  <ListItemIcon sx={{ minWidth: isCompact ? "auto" : 56 }}>
                    {item.icon}
                  </ListItemIcon>
                  {!isCompact && (
                    <>
                      <ListItemText>
                        <div id="titleMenu">{item.title}</div>
                      </ListItemText>
                      {item.subMenu?.length &&
                        (item.collapseIsOpen ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        ))}
                    </>
                  )}
                  {isCompact && item.subMenu?.length && (
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 2,
                        right: 2,
                        fontSize: "12px",
                        color: "#58595B",
                      }}
                    >
                      {item.collapseIsOpen ? (
                        <ExpandLessIcon sx={{ fontSize: "12px" }} />
                      ) : (
                        <ExpandMoreIcon sx={{ fontSize: "12px" }} />
                      )}
                    </Box>
                  )}
                </ListItem>
              </Tooltip>
            )}

            {item.collapseIsOpen && (
              <Collapse
                in={item.collapseIsOpen}
                timeout="auto"
                unmountOnExit
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  overflow: "hidden",
                  "& .MuiCollapse-wrapper": {
                    width: "100%",
                    maxWidth: "100%",
                  },
                  "& .MuiCollapse-wrapperInner": {
                    width: "100%",
                    maxWidth: "100%",
                  },
                }}
              >
                {item.subMenu?.map((subItem, indexSubMenu) => (
                  <List
                    key={indexSubMenu}
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                      overflow: "hidden",
                      padding: 0,
                    }}
                  >
                    <Tooltip
                      title={isCompact ? subItem.title : ""}
                      placement="right"
                    >
                      <ListItem
                        component="div"
                        selected={location.pathname.includes(subItem.to)}
                        onClick={() => navigate(subItem.to)}
                        sx={{
                          pl: isCompact ? 2 : 4,
                          borderRadius: "4px",
                          justifyContent: isCompact ? "center" : "flex-start",
                          width: "100%",
                          maxWidth: "100%",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:hover": {
                            background: "rgba(88, 89, 91, 0.10);",
                            "& .MuiListItem-root": {
                              bgcolor: "rgba(88, 89, 91, 0.10)",
                            },
                          },
                          ...(location.pathname.includes(subItem.to) && {
                            color: "#E20F1A",
                            filter: generateFilter("#E20F1A"),
                          }),
                        }}
                      >
                        {subItem.icon != null ? (
                          <Box
                            sx={{
                              mr: isCompact ? 0 : 1,
                              fontSize: "0.8rem",
                              color: "#58595B",
                              "& .MuiSvgIcon-root": {
                                fontSize: "16px",
                              },
                            }}
                          >
                            {subItem.icon}
                          </Box>
                        ) : (
                          <StyledIcon
                            iconType="dot"
                            sx={{
                              width: "0.6rem",
                              height: "0.6rem",
                              mr: isCompact ? 0 : 1,
                            }}
                          />
                        )}
                        {!isCompact && (
                          <div id="subTitleMenu">{subItem.title}</div>
                        )}
                      </ListItem>
                    </Tooltip>
                  </List>
                ))}
              </Collapse>
            )}
          </List>
        ))}

        {menuFooter?.map((item, index) => (
          <List key={index}>
            {!isCompact && (
              <div id="home" className="footerTitle">
                {item.title}
              </div>
            )}
            {item.subMenu?.map((subItem, indexSubMenu) => (
              <List key={indexSubMenu}>
                <Tooltip
                  title={isCompact ? subItem.title : ""}
                  placement="right"
                >
                  <ListItem
                    component={Link}
                    to={subItem.to}
                    selected={location.pathname.includes(subItem.module)}
                    sx={{
                      borderRadius: "4px",
                      justifyContent: isCompact ? "center" : "flex-start",
                      px: isCompact ? 1 : 2,
                      "& .MuiSvgIcon-root": {
                        color: "#58595B",
                      },

                      "&:hover": {
                        background: "rgba(226, 15, 26, 0.1);",
                        color: "#E20F1A",
                        cursor: "pointer",
                        filter: generateFilter("#E20F1A"),
                      },
                      ...(location.pathname.includes(subItem.module)
                        ? {
                            color: "#E20F1A",
                            filter: generateFilter("#E20F1A"),
                            bgcolor: "rgba(226, 15, 26, 0.1);",
                          }
                        : {
                            "&.Mui-selected": {
                              backgroundColor: "transparent",
                              color: "#E20F1A",
                              filter: generateFilter("#E20F1A"),
                            },
                          }),
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: isCompact ? "auto" : 56 }}>
                      {subItem.icon}
                    </ListItemIcon>
                    {!isCompact && (
                      <ListItemText>
                        <div id="titleMenu">{subItem.title}</div>
                      </ListItemText>
                    )}
                  </ListItem>
                </Tooltip>
              </List>
            ))}
          </List>
        ))}
      </List>
    </Box>
  );
};
export default listItemSideBar;
